import axios from '@/utils/axios';
import { messages } from '@/utils';
import * as types from '../mutations-types';

const state = {
    loading: false,
    // token: '', esta en rootState
    user: {}
};

const getters = {
    getUser: state => {
        return state.user;
    }
};

const mutations = {
    [types.LOADING](state, value) {
        state.loading = typeof value !== 'undefined' ? value : true;
    },
    [types.SET_USER](state, user) {
        state.user = user;
    }
};

const actions = {
    async signOut({ commit, dispatch }) {
        dispatch('deleteToken', null, { root: true });
        commit(types.LOADING); // show spinner
        try {
            await axios.get('/auth/signout');
        } catch (e) {
            if (e.status === 400) {
                return {
                    error: e
                };
            }
            return { error: messages.api };
        } finally {
            commit(types.LOADING, false);
        }
    },

    async getMe({ commit, dispatch, rootState }) {
        try {
            if (!rootState.token) {
                return {
                    user: null,
                    error: null
                };
            }
            commit(types.LOADING); // show spinner
            const { data } = await axios.get('/auth/me');
            const user = data.data;
            if (user.id) {
                commit(types.SET_USER, user);
            } else {
                // axios cuando recibe 403
                if (rootState.token) {
                    dispatch('signOut');
                }
            }
            return data;
        } catch (err) {
            dispatch('signOut');
            return {
                error: messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    },

    async signIn({ commit }, { username, password }) {
        try {
            commit(types.LOADING); // show spinner
            const { status, data } = await axios.post('/auth/signin', {
                username,
                password
            });
            const { user, token } = data.data;
            if (status === 200 && token) {
                commit(types.SET_TOKEN, token, {
                    root: true
                });
                typeof user !== 'undefined' && commit(types.SET_USER, user);
            }
            return { data: user };
        } catch ({ status, error }) {
            return {
                error:
                    status === 401
                        ? 'Usuario o Contraseña incorrecto.'
                        : messages.api.error
            };
        } finally {
            commit(types.LOADING, false);
        }
    }

    /* async signUp({ commit }, formObj) {
    try {
      commit(types.LOADING); // show spinner
      const { data } = await axios
        .post("/auth/logout", {
          apellido: formObj.apellido.toLowerCase(),
          nombre: formObj.nombre.toLowerCase(),
          tipoDocumento: formObj.tipoDocumento,
          numeroDocumento: formObj.numeroDocumento,
          TipoUsuario: formObj.TipoUsuario,
          mail: formObj.mail.toLowerCase(),
          password: formObj.password
        })
        .finally(() => commit(types.LOADING, false));
      return { data };
    } catch ({ status, data }) {
      switch (status) {
        case 400:
          return {
            // error: data.errors.map(err => err.defaultMessage)
            error: data.errors[0].defaultMessage
          };
        case 406:
          return { error: "El mail ya está registrado." };
        default:
          return { error: messages.api.error };
      }
    }
  }, */

    /* async changePassword({ commit }, { actualPassword, newPassword }) {
    try {
      commit(types.LOADING); // show spinner
      const { data } = await axios.post("/auth/changeOwnPassword", {
        actualPassword,
        newPassword
      });
      return { data: data.data, error: null };
    } catch ({ error, status }) {
      return {
        error: status === 404 ? error : messages.api.error
      };
    } finally {
      commit(types.LOADING, false);
    }
  } */
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
